/*********************** Custom JS for Boost AI Search & Discovery  ************************/
const customize = {
    customizeProductItem: (componentRegistry) => {
        function updateBadges(element) {
            const productData = element.getParams().props.product;
            let productId = productData.id;

            if (productData?.split_product) {
                productId = productData.variant_id;
            }

            const productItem = document.querySelector(`[data-product-id="${productId}"]`);
            const productHandle = productData.handle;
            productItem?.setAttribute('data-product-handle', productHandle);

        /* This HIDES the Gift Bag from any Boost Sliders such as recommended Products */
            if (productItem && productId === 7084090589219) {
                // Hide the parent `.boost-sd__slide`
                const parentSlide = productItem.closest('.boost-sd__slide');
                if (parentSlide) {
                    parentSlide.style.display = 'none';
                }
        
                // Hide the associated `.slick-slide`
                const slickSlide = productItem.closest('.slick-slide');
                if (slickSlide) {
                    slickSlide.style.display = 'none';
                }
            }
          
            if (productItem && productData) {
            const topImgRowLeft = productItem.querySelector('.boost-sd__product-image-column--in-top.boost-sd__product-image-column--left');
            const topImgRowRight = productItem.querySelector('.boost-sd__product-image-column--in-top.boost-sd__product-image-column--right');
            const bottomImgRowRight = productItem.querySelector('.boost-sd__product-image-column--in-bottom.boost-sd__product-image-column--right');
            

              
                const saleLabelHtml = `
                    <span class="boost-sd-custom-sale-label">
                        <img src="https://cdn.shopify.com/s/files/1/0289/5219/9203/files/sale-red.jpg?v=1703197678" alt="Sale">
                    </span>
                `;
              
                const PromoLabelsHtml = buildPromoLabels(productData);
              
                const badgeLabelsHtml = buildBadgeLabels(productData);
          
                const wishlistHtml = `
                    <button class="button-add-remove-wishlist button boost-pfs-wishlistbtn" type="button" onclick="onClickEgWishlistButton(this, event)" style="display: block;">
                <span data-add="" style="display: inline-flex;">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="icon icon-wishlist bi bi-heart" viewBox="0 0 16 16">
                        <path d="m8 2.748-.717-.737C5.6.281 2.514.878 1.4 3.053c-.523 1.023-.641 2.5.314 4.385.92 1.815 2.834 3.989 6.286 6.357 3.452-2.368 5.365-4.542 6.286-6.357.955-1.886.838-3.362.314-4.385C13.486.878 10.4.28 8.717 2.01L8 2.748zM8 15C-7.333 4.868 3.279-3.04 7.824 1.143c.06.055.119.112.176.171a3.12 3.12 0 0 1 .176-.17C12.72-3.042 23.333 4.867 8 15z"/>
                    </svg>
                    <span class="visually-hidden">
                        Add to wishlist
                    </span>
                </span>
                <span data-remove="" style="display: none;">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="icon icon-wishlist bi bi-heart-fill" viewBox="0 0 16 16">
                        <path fill-rule="evenodd" d="M8 1.314C12.438-3.248 23.534 4.735 8 15-7.534 4.736 3.562-3.248 8 1.314z"/>
                    </svg>
                    <span class="visually-hidden">
                        Remove from wishlist
                    </span>
                </span>
            </button>
                `;

                // if (topImgRowRight) {
                //     topImgRowRight.append = badgeLabelsHtml;
                // }

              //adds Plus more badge container to product image wrapper
              if(!productItem.querySelector(".custom-promo-label")){
                productItem.querySelector(".boost-sd__product-image-wrapper").insertAdjacentHTML("beforeend", PromoLabelsHtml)
              }
              
              if(!productItem.querySelector(".custom-tag-label")){
                productItem.querySelector(".boost-sd__product-image-row--bottom").insertAdjacentHTML("beforeend", badgeLabelsHtml)
              }
              
                if (bottomImgRowRight) {
                    bottomImgRowRight.innerHTML = wishlistHtml;
                }
                if (topImgRowLeft && productData?.percent_sale_min > 0) {
                    topImgRowLeft.innerHTML = saleLabelHtml;
                }
            }
        }

        // Build functions
        const buildBadgeLabels = (data) => {
        
            let badgeLabel = '';

            if (data.tags) {
                for (let i = 0; i < data.tags.length; i++) {
                    const tag = data.tags[i];
                    if (tag.indexOf('2FOR99') !== -1) {
                        const preBadgeLabel = '<div class="custom-tag-label"><img class="custom-tag-label-img" src="https://cdn.shopify.com/s/files/1/0289/5219/9203/files/2FOR99_b9c517ae-b897-4dad-b12c-78dc8d5208ec.svg"></div>';
                        badgeLabel += preBadgeLabel;
                        break;
                    } else if (tag.indexOf('2FOR100') !== -1) {
                        const preBadgeLabel = '<div class="custom-tag-label"><img class="custom-tag-label-img" src="https://cdn.shopify.com/s/files/1/0289/5219/9203/files/2FOR100_13362ab2-b036-4b03-a880-a4b5b282a926.svg"></div>';
                        badgeLabel += preBadgeLabel;
                        break;
                    } else if (tag.indexOf('2FOR120') !== -1) {
                        const preBadgeLabel = '<div class="custom-tag-label"><img class="custom-tag-label-img" src="https://cdn.shopify.com/s/files/1/0289/5219/9203/files/2FOR120_4f3e5265-f376-4595-ae58-41f4d88754f1.svg"></div>';
                        badgeLabel += preBadgeLabel;
                        break;
                    } else if (tag.indexOf('2FOR150') !== -1) {
                        const preBadgeLabel = '<div class="custom-tag-label"><img class="custom-tag-label-img" src="https://cdn.shopify.com/s/files/1/0289/5219/9203/files/2FOR150_fe202ce5-ac04-46c3-a432-1063687b3bc5.svg"></div>';
                        badgeLabel += preBadgeLabel;
                        break;
                    } else if (tag.indexOf('2FOR160') !== -1) {
                        const preBadgeLabel = '<div class="custom-tag-label"><img class="custom-tag-label-img" src="https://cdn.shopify.com/s/files/1/0289/5219/9203/files/2FOR160_37705c59-487c-4df0-8ab8-ce855129b7d0.svg"></div>';
                        badgeLabel += preBadgeLabel;
                        break;
                    } else if (tag.indexOf('2FOR170') !== -1) {
                        const preBadgeLabel = '<div class="custom-tag-label"><img class="custom-tag-label-img" src="https://cdn.shopify.com/s/files/1/0289/5219/9203/files/2FOR170_cbaebb85-abe5-45f1-a17b-dc7db4d597be.svg"></div>';
                        badgeLabel += preBadgeLabel;
                        break;
                    } else if (tag.indexOf('2FOR200') !== -1) {
                        const preBadgeLabel = '<div class="custom-tag-label"><img class="custom-tag-label-img" src="https://cdn.shopify.com/s/files/1/0289/5219/9203/files/2FOR200_f026bf48-7352-4c3f-84a1-e7baf6b466d0.svg"></div>';
                        badgeLabel += preBadgeLabel;
                        break;
                    } else if (tag.indexOf('2FOR250') !== -1) {
                        const preBadgeLabel = '<div class="custom-tag-label"><img class="custom-tag-label-img" src="https://cdn.shopify.com/s/files/1/0289/5219/9203/files/2FOR250_ab027ff8-b17a-45ce-82f1-37b54eca3cd5.svg"></div>';
                        badgeLabel += preBadgeLabel;
                        break;
                    } else if (tag.indexOf('2FOR270') !== -1) {
                        const preBadgeLabel = '<div class="custom-tag-label"><img class="custom-tag-label-img" src="https://cdn.shopify.com/s/files/1/0289/5219/9203/files/2FOR270_78d35723-5104-469e-b117-8d4acd9abba7.svg"></div>';
                        badgeLabel += preBadgeLabel;
                        break;
                    } else if (tag.indexOf('2FOR300') !== -1) {
                        const preBadgeLabel = '<div class="custom-tag-label"><img class="custom-tag-label-img" src="https://cdn.shopify.com/s/files/1/0289/5219/9203/files/2FOR300_4ff629ab-b1ca-4c2d-a5bb-7cb929b9a43d.svg"></div>';
                        badgeLabel += preBadgeLabel;
                        break;
                    } else if (tag.indexOf('2FOR350') !== -1) {
                        const preBadgeLabel = '<div class="custom-tag-label"><img class="custom-tag-label-img" src="https://cdn.shopify.com/s/files/1/0289/5219/9203/files/2FOR350_2af4a624-bccb-4a81-b0ad-9a63d8bf9bf2.svg"></div>';
                        badgeLabel += preBadgeLabel;
                        break;
                    } else if (tag.indexOf('2FOR360') !== -1) {
                        const preBadgeLabel = '<div class="custom-tag-label"><img class="custom-tag-label-img" src="https://cdn.shopify.com/s/files/1/0289/5219/9203/files/2FOR360_71ccc807-6150-4da6-b7c2-9bb04ae21d2d.svg"></div>';
                        badgeLabel += preBadgeLabel;
                        break;
                    } else if (tag.indexOf('2FOR400') !== -1) {
                        const preBadgeLabel = '<div class="custom-tag-label"><img class="custom-tag-label-img" src="https://cdn.shopify.com/s/files/1/0289/5219/9203/files/2FOR400_7b1e5013-a6f6-46f3-9984-d260342a0b44.svg"></div>';
                        badgeLabel += preBadgeLabel;
                        break;
                    } else if (tag.indexOf('2FOR450') !== -1) {
                        const preBadgeLabel = '<div class="custom-tag-label"><img class="custom-tag-label-img" src="https://cdn.shopify.com/s/files/1/0289/5219/9203/files/2FOR450_324c735a-763e-4beb-aa8d-2f5ea24b4881.svg"></div>';
                        badgeLabel += preBadgeLabel;
                        break;
                    } else if (tag.indexOf('2FOR500') !== -1) {
                        const preBadgeLabel = '<div class="custom-tag-label"><img class="custom-tag-label-img" src="https://cdn.shopify.com/s/files/1/0289/5219/9203/files/2FOR500_4d178440-f6fd-4139-8784-7caf336ca98b.svg"></div>';
                        badgeLabel += preBadgeLabel;
                        break;
                    } else if (tag.indexOf('2FOR550') !== -1) {
                        const preBadgeLabel = '<div class="custom-tag-label"><img class="custom-tag-label-img" src="https://cdn.shopify.com/s/files/1/0289/5219/9203/files/2FOR550_9e2dfc26-3b4e-44a8-bef8-b70fca1621c2.svg"></div>';
                        badgeLabel += preBadgeLabel;
                        break;
                    } else if (tag.indexOf('50P_OFF') !== -1) {
                        const preBadgeLabel = '<div class="custom-tag-label"><img class="custom-tag-label-img" src="https://cdn.shopify.com/s/files/1/0289/5219/9203/files/50OFF_c21832f3-fb0a-41a0-a6f6-4230d9601fbc.svg"></div>';
                        badgeLabel += preBadgeLabel;
                        break;
                    } else if (tag.indexOf('50OFF') !== -1) {
                        const preBadgeLabel = '<div class="custom-tag-label"><img class="custom-tag-label-img" src="https://cdn.shopify.com/s/files/1/0289/5219/9203/files/50OFF_c21832f3-fb0a-41a0-a6f6-4230d9601fbc.svg"></div>';
                        badgeLabel += preBadgeLabel;
                        break;
                    } else if (tag.indexOf('BUY2GET1') !== -1) {
                        const preBadgeLabel = '<div class="custom-tag-label"><img class="custom-tag-label-img" src="https://cdn.shopify.com/s/files/1/0289/5219/9203/files/BUY2GET1_D_9279369c-9f1d-4e40-a52e-0508ea296b80.svg"></div>';
                        badgeLabel += preBadgeLabel;
                        break;
                    } else if (tag.indexOf('2FOR140') !== -1) {
                        const preBadgeLabel = '<div class="custom-tag-label"><img class="custom-tag-label-img" src="https://cdn.shopify.com/s/files/1/0289/5219/9203/files/2FOR140_eff8b829-75bc-4355-877e-dee83cc1b57f.svg"></div>';
                        badgeLabel += preBadgeLabel;
                        break;
                    } else if (tag.indexOf('2FOR320') !== -1) {
                        const preBadgeLabel = '<div class="custom-tag-label"><img class="custom-tag-label-img" src="https://cdn.shopify.com/s/files/1/0289/5219/9203/files/2FOR320_3edad950-ecd7-4c64-ada2-18b62f3ef6e2.svg"></div>';
                        badgeLabel += preBadgeLabel;
                        break;
                   } else if (tag.indexOf('R100OFF') !== -1) {
                        const preBadgeLabel = '<div class="custom-tag-label"><img class="custom-tag-label-img" src="https://cdn.shopify.com/s/files/1/0289/5219/9203/files/R100OFF_47a87a41-e96d-48c5-b75c-5d5863dcb579.svg"></div>';
                        badgeLabel += preBadgeLabel;
                        break;
                   } else if (tag.indexOf('20P_OFF') !== -1) {
                        const preBadgeLabel = '<div class="custom-tag-label"><img class="custom-tag-label-img" src="https://cdn.shopify.com/s/files/1/0289/5219/9203/files/20P_OFF_7895a793-545f-40de-bd0e-355ddb1ed9b5.svg"></div>';
                        badgeLabel += preBadgeLabel;
                        break;
                   } else if (tag.indexOf('30_p') !== -1) {
                        const preBadgeLabel = '<div class="custom-tag-label"><img class="custom-tag-label-img" src="https://cdn.shopify.com/s/files/1/0289/5219/9203/files/30_p.svg?v=1736756575"></div>';
                        badgeLabel += preBadgeLabel;
                        break;
                   } else if (tag.indexOf('PLUSMORE') !== -1) {
                        const preBadgeLabel = '<div class="custom-tag-label"><img class="custom-tag-label-img" src="https://cdn.shopify.com/s/files/1/0289/5219/9203/files/PLUSMORE_6a298e01-4e81-45c1-b9a6-92966c604532.svg"></div>';
                        badgeLabel += preBadgeLabel;
                        break;
                   } else if (tag.indexOf('PLUSMORE') !== -1) {
                        const preBadgeLabel = '<div class="custom-tag-label"><img class="custom-tag-label-img" src="https://cdn.shopify.com/s/files/1/0289/5219/9203/files/plusmore2.svg"></div>';
                        badgeLabel += preBadgeLabel;
                        break;
                   } else if (tag.indexOf('4FOR100') !== -1) {
                        const preBadgeLabel = '<div class="custom-tag-label"><img class="custom-tag-label-img" src="https://cdn.shopify.com/s/files/1/0289/5219/9203/files/4FOR100_9dec0692-1b6a-4a14-b1f9-c25d863e82fd.svg"></div>';
                        badgeLabel += preBadgeLabel;
                        break;
                    }
                }
            }

            return badgeLabel;
        }

        // Build functions
        const buildPromoLabels = (data) => {
            let PromoLabel = '';

            if (data.tags) {
                for (let i = 0; i < data.tags.length; i++) {
                    const tag = data.tags[i];
                    if (tag.indexOf('PLUSMORE') !== -1) {
                        const prePromoLabel = '<div class="custom-promo-label"><img class="custom-promo-label-img" src="https://cdn.shopify.com/s/files/1/0289/5219/9203/files/plusmore_badge.svg"></div>';
                        PromoLabel += prePromoLabel;
                        break;
                    } else if (tag.indexOf('LOXIONKULCA') !== -1) {
                        const prePromoLabel = '<div class="custom-promo-label"><img class="custom-promo-label-image" src="https://cdn.shopify.com/s/files/1/0289/5219/9203/files/loxion_v2.svg?v=1744097673"></div>';
                        PromoLabel += prePromoLabel;
                        break;
                    }
                }
            }
            return PromoLabel;
        };
      
        // Update grid view & list view
        const updateProductItemGridView = {
            name: 'Update badges for grid view #182836',
            enabled: true,
            apply: () => ({
                afterRender(element) {
                    updateBadges(element);
                }
            })
        };

        const updateProductItemListView = {
            name: 'Update badges for list view #182836',
            enabled: true,
            apply: () => ({
                afterRender(element) {
                    updateBadges(element);
                }
            })
        };

        // Update Default image
        const updateDefaultImage = {
            name: 'Update default image for product no image',
            enabled: true,
            apply: () => ({
                props(props, element) {
                    try {
                        if (props?.images && props.images.length > 0) {
                            let image = props.images[0];
                            if (image.indexOf('boost-pfs-no-image.jpg') != -1) {
                                if (typeof boostSDCustom !== 'undefined' && boostSDCustom?.asset_url) {
                                    let newUrl = 'https:' + boostSDCustom.asset_url.split('boost-pfs.js')[0] + 'boost-pfs-no-image.jpg';
                                    props.images[0] = newUrl;
                                }
                            }
                        }
                        return props;
                    } catch(error) {
                        console.log(error);
                    }
                }
            })
        };

        // Register updateProductList When ProductList is rendered
        componentRegistry.useComponentPlugin('ProductItem', updateProductItemGridView);
        componentRegistry.useComponentPlugin('ProductItemListViewLayout', updateProductItemListView);
        componentRegistry.useComponentPlugin('ProductImage', updateDefaultImage);
    }
}

window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([
    customize.customizeProductItem
]);

window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([
   (componentRegistry) => {
      componentRegistry.useComponentPlugin('FormatCurrency', {
         name: 'Show Trailing Zeros',
         apply: () => ({
            afterRender: (element) => {
               try {
                  // Start customization--------------------------------------------
                  const formatMoneyHelper = element.getHelpers().formatMoney;
									if (!formatMoneyHelper) return;
                  const value = element.getParams().props.value; // Get price
                  const customValue = formatMoneyHelper(Number(value), window.boostSDAppConfig?.shop?.money_format, true);

                 setTimeout(() => {
                   element.getRootElm().querySelector('.boost-sd__format-currency span').innerHTML = customValue;
                 }, 1000)
                  
                  // End-------------------------------------------------------------
               } catch (e) {
                  console.error(e);
               }
            },
         }),
      });
   }
]);


const customizeTitle = {
   updateProductItemGrid: (componentRegistry) => {
      componentRegistry.useComponentPlugin('ProductItem', {
         name: 'Add extra information',
         enabled: true,
         apply: () => ({
            afterRender(element) {
               try {
                  // Start customization--------------------------------------------
                  let productData = element.getParams().props.product;
                  let productId = productData.id;
                  if (productData?.split_product) {
                     productId = productData.variant_id;
                  }
                  let productItem = document.querySelector('[data-product-id="' + productId + '"]');
                  if (productItem) {
                  console.log() 
                     productItem.querySelector(".boost-sd__product-title").innerHTML = productData.title.split("_")[0]
                  }
                  // End-------------------------------------------------------------
               } catch (e) {
                  console.error(e);
               }
            }
         }),
      });
   },
  updateRecommendation: (registry) => {
    registry.useModulePlugin('RecommendationAPI', {
      name: 'Customize Recommendation',
      apply(builder) {
        builder.on('methodFulfilled', 'get', (result) => {
          let recommendationProducts = result.result.products;
          if(recommendationProducts.length > 0){
            for(let i = 0; i < recommendationProducts.length; i++){
              setTimeout(function () {
                let productItems = document.querySelectorAll(`.boost-sd__product-item[data-product-id="`+ recommendationProducts[i].id +`"]`);
                productItems.forEach(function(productItem){
                  const productData = recommendationProducts[i]; // Get product data
									// Custom code goes here
									// Start example - Add percent sale label
                  if (productData.percent_sale_min > 0) {
                    const customSaleLabel = `<span class="product-label product-label--sale">
                                                <span>- ${productData.percent_sale_min}%</span>
                                              </span>`
                    productItem.querySelector('.boost-sd__product-image-column--left').innerHTML = customSaleLabel;
                  }
									// End example
                });
              }, 500)
            }
          }
        });
      }
    });
  },

}

window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([customizeTitle.updateProductItemGrid, customizeTitle.updateRecommendation]);




window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat((registry) => {
  registry.useModulePlugin('RecommendationAPI', {
    name: 'Customize Recommendation',
    apply(builder) {
      builder.on('methodFulfilled', 'get', (result) => {
        if(result.result.products.length > 0){
          for(var j = result.result.products.length - 1; j >= 0; j--){
           
            result.result.products[j].title =  result.result.products[j].title.split("_")[0]
            
          }
        }
      });
    },
  });
})


const customizeISW = {
   updateProductItemISW: (componentRegistry) => {
      componentRegistry.useComponentPlugin('SearchProductItem', {
         name: 'Customize product item ISW',
         enabled: true,
         apply: () => ({
            afterRender(element) {
               try {
                  // Start customization--------------------------------------------
                  let productData = element.getParams().props.product;
                  let productId = productData.id;
                  if (productData?.split_product) {
                     productId = productData.variant_id;
                  }
                  let productItem = document.querySelector('.boost-sd__suggestion-queries-item--product[data-id="' + productId + '"]');
                  if (productItem) {
                    productItem.querySelector('.boost-sd__suggestion-queries-item-title').innerHTML = productData.title.split("_")[0]
                  }
                  // End-------------------------------------------------------------
               } catch (e) {
                  console.error(e);
               }
            }
         }),
      });
   }
}

window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([customizeISW.updateProductItemISW]);

